import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const UseFilterIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_498_78501)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.5 1.25C4.25736 1.25 3.25 2.25736 3.25 3.5V16.5C3.25 17.7426 4.25736 18.75 5.5 18.75H14.5C15.7426 18.75 16.75 17.7426 16.75 16.5V3.5C16.75 2.25736 15.7426 1.25 14.5 1.25H5.5ZM4.75 3.5C4.75 3.08579 5.08579 2.75 5.5 2.75H14.5C14.9142 2.75 15.25 3.08579 15.25 3.5V16.5C15.25 16.9142 14.9142 17.25 14.5 17.25H5.5C5.08579 17.25 4.75 16.9142 4.75 16.5V3.5ZM10 15C11.1046 15 12 14.1046 12 13C12 11.8954 11.1046 11 10 11C8.89543 11 8 11.8954 8 13C8 14.1046 8.89543 15 10 15Z"
          fill={fillColor || '#9D9DA6'}
        />
      </g>
      <defs>
        <clipPath id="clip0_498_78501">
          <rect width="20" height="20" fill={fillColor || 'white'} />
        </clipPath>
      </defs>
    </svg>
  );
};

export { UseFilterIcon };
